// @ts-ignore
import { useRouter as useNextRouter } from "nextjs-toploader/app";

export const useRouter = () => {
  return useNextRouter();
};
